module.exports = __webpack_public_path__ + "img/root-addr.1bf13af3.svg";